"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const ModalIndividualRevokeAccess_vue_1 = __importDefault(require("./ModalIndividualRevokeAccess.vue"));
const AccessData_1 = __importDefault(require("@becrop/components/Profile/Access/class/models/AccessData"));
let DistributorImgsList = class DistributorImgsList extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.distributorId = 0;
        this.isIndividualRevokeAccessModal = false;
    }
    recall() {
        this.$emit('recall');
    }
    dismissIndividualRevokeAccessModal() {
        this.isIndividualRevokeAccessModal = false;
    }
    openIndividualRevokeAccessModal() {
        this.isIndividualRevokeAccessModal = true;
    }
    individualProjectRevoke(data) {
        this.$emit('individualProjectRevoke', data);
    }
    individualSampleRevoke(data) {
        this.$emit('individualSampleRevoke', data);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new AccessData_1.default() })
], DistributorImgsList.prototype, "dataSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], DistributorImgsList.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], DistributorImgsList.prototype, "sampleId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], DistributorImgsList.prototype, "projectId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], DistributorImgsList.prototype, "distributorsIds", void 0);
DistributorImgsList = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ModalIndividualRevokeAccess: ModalIndividualRevokeAccess_vue_1.default,
        },
    })
], DistributorImgsList);
exports.default = DistributorImgsList;
